import * as React from 'react'

import { Template } from './Template'
import { useViewModel } from './useViewModel'

export const SearchPageView: React.FC<Parameters<typeof useViewModel>[0]> = props => {
  return <Template {...useViewModel(props)} />
}
